import React from "react";
import styles from '../cookies/CookiesExternal.module.css';
import FooterExternal from "../../footer/FooterExternal";
import PrivacyPolicyContent from "../../privacyPolicy/PrivacyPolicyContent";
import { useNavigate } from "react-router-dom";
import HiQFooterExternal from "../../footer/HiQFooterExternal";

export default function HiQPrivacyPolicyExternal(){

    const navigate = useNavigate();

    const navigateToLogin = () => {
        navigate('/hiq');
    }

    return (
        <>
            <main className={`${styles.background} ${styles.hiq}`}>
                <div className={styles.overlay}></div>
                <div className={styles.paneContainer}>
                    <div className={styles.pane}>
                        <div className={styles.paneLower}>
                            <h3>Privacy Policy</h3>
                            <br/>
                            <PrivacyPolicyContent/>
                            <button onClick={navigateToLogin} className={styles.returnBtn}>Go to Login</button>
                        </div>
                    </div>
                </div>
            </main>
            <HiQFooterExternal />
        </>
    )
}